import { SELECT_MENU_PORTAL_CLASS } from '~shared/components/select/helper';

export { SELECT_MENU_PORTAL_CLASS };

export const isEnrollConfirmationHeld = (
  showConfirmation: boolean,
  holdDismiss: boolean,
) => showConfirmation || holdDismiss;

export const shouldIgnoreEnrollDialogClose = (
  nextOpen: boolean,
  confirmationHeld: boolean,
) => !nextOpen && confirmationHeld;

/**
 * Body-portaled react-select menus sit outside DialogContent. Treat those
 * clicks as "inside" so Radix does not dismiss the non-modal enroll picker.
 * Prefer portaling into DialogContent when possible — preventDefault on
 * pointer-down can also cancel the option click itself.
 */
export const isEventFromSelectMenuPortal = (
  target: EventTarget | null,
): boolean => {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest(`.${SELECT_MENU_PORTAL_CLASS}`));
};

export const preventDismissWhenConfirming = (
  event: { preventDefault: () => void },
  confirmationHeld: boolean,
) => {
  if (confirmationHeld) {
    event.preventDefault();
  }
};

/**
 * Focus leaving the class picker must not close it. The age-range warning and
 * the confirm dialog both move focus, and a non-modal picker treats that as
 * dismiss. Pointer clicks outside still close it, except while confirming.
 */
export const shouldPreventEnrollDialogDismiss = (
  eventKind: 'focus' | 'pointer',
  confirmationHeld: boolean,
) => eventKind === 'focus' || confirmationHeld;

export const preventDismissForSelectMenuOrConfirm = (
  event: {
    preventDefault: () => void;
    target?: EventTarget | null;
  },
  confirmationHeld: boolean,
) => {
  if (confirmationHeld || isEventFromSelectMenuPortal(event.target ?? null)) {
    event.preventDefault();
  }
};
